import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { ComponentStoreFactory } from '../../../../shared/store/common/component-store.factory';
import { ServiceService } from '../../../../../services/service.service';
import { selectCurrentOrganizationId } from '../../../../../store/global/global.selectors';
import { toSignal } from '@angular/core/rxjs-interop';
import { globalStore } from '../../../../shared/shared.global-service';
import { selectCurrentServiceId, selectFolder, selectServices } from '../../../store/person/person.selectors';
import { map } from 'rxjs/operators';
import { getSharingFolderIds } from '../../../../../utils/folder.utils';
import { SERVICE_SETTINGS_NURSE_RECORD_TYPE_KEY } from '@libs/types/src/services/types/common-service-settings.type';

interface State {
}

const defaultState: State = {
};

@Injectable()
export class FolderNurseRecordsPageStore extends ComponentStoreFactory<State, ServiceService> {

    organizationId$ = this.globalStore!.select(selectCurrentOrganizationId);

    folder = toSignal(this.globalStore!.select(selectFolder));
    serviceId = toSignal(this.globalStore!.select(selectCurrentServiceId));

    nurseRecordSharingIds = toSignal(globalStore!.select(selectServices).pipe(
        map((services) =>
            getSharingFolderIds(this.serviceId(), services, this.folder()?.relatedFolders, SERVICE_SETTINGS_NURSE_RECORD_TYPE_KEY)),
    ));

    constructor() {
        super(defaultState, inject(Store), inject(ServiceService));
    }
}
